/* tslint:disable */
export const fr_overrides_strings = {
};
